/**
 * CONCURENS module API — embedded in app.markbase.ru until concurens-backend compose (phase-8).
 */
const appOrigin = (() => {
  const raw = String(process.env.REACT_APP_API_URL || 'https://app.markbase.ru').replace(/\/+$/, '');
  try {
    return new URL(raw).origin;
  } catch (_e) {
    return 'https://app.markbase.ru';
  }
})();

export const CONCURENS_API_ADMIN_BASE =
  process.env.REACT_APP_CONCURENS_API_URL || `${appOrigin}/api/concurens/v1/admin`;

export const CONCURENS_APP_MAP_ROUTE = `${appOrigin.replace(/\/+$/, '')}/admin/concurens/map`;
